module.exports = __webpack_public_path__ + "img/paid.366e4355.png";